import { useSelector } from "react-redux";
import {
  addressModalInitialState,
  invalidAddressModalInitialState,
  verifyAddressModalInitialState,
} from "./layoutReducer";

export const useCurrentUser = () => useSelector((state) => state.layout.currentUser);
export const useCurrentSuperUser = () => useSelector((state) => state.layout?.currentSuperUser);
export const useFeatureFlags = () => useSelector((state) => state.layout.featureFlags);
export const useAccountProducts = () => useSelector((state) => state.layout.accountProducts ?? {});
export const useTheme = () => useSelector((state) => state.layout.theme);
export const useDialerServiceUrl = () => useSelector((state) => state.layout.apiUrls.dialerServiceUrl);
export const useTwilioRecordingStartSoundUrl = () =>
  useSelector((state) => state.phoneSettings?.twilioRecordingStartSoundUrl);
export const useCallRecordingSettings = () =>
  useSelector((state) => state.layout.currentUser?.callRecordingSettings);
export const useAccountCallRecordingLoading = () =>
  useSelector((state) => state.layout.accountCallRecordingLoading);
export const useAccountCallRecordingSettings = () =>
  useSelector((state) => state.layout.currentUser.account?.callRecordingSettings);
export const useIsTwoPartyState = () => useSelector((state) => state.phoneSettings?.twoPartyState);
export const useIsTwoPartyStateCurrentUser = () =>
  useSelector((state) => state.layout.currentUser.account?.twoPartyState);
export const useIsAdmin = () => useSelector((state) => state.layout.currentUser.account?.isAdmin);
export const useAcccountUuid = () => useSelector((state) => state.layout.currentUser.account?.uuid);
export const useIsPlace = () => useSelector((state) => state.layout.currentUser.account?.isPlace);
export const useIsLever = () => useSelector((state) => state.layout.currentUser.account?.isLever);

export const useOutboundCallRecordingSetting = () => {
  const callRecordingSettings = useCallRecordingSettings();
  const accountCallRecordingSettings = useAccountCallRecordingSettings();
  const outboundRecording =
    accountCallRecordingSettings?.outboundRecording === "by_number"
      ? callRecordingSettings?.outboundRecording || "disabled"
      : accountCallRecordingSettings?.outboundRecording;
  const outboundNotificationMessage =
    accountCallRecordingSettings?.outboundNotificationMessageCondition !== "never";

  return {
    outboundRecording,
    outboundNotificationMessage,
    outboundNotificationMessageCondition: accountCallRecordingSettings?.outboundNotificationMessageCondition,
  };
};

export const useMessagingServiceUrl = () => useSelector((state) => state.layout.apiUrls.messagingServiceUrl);
export const useAiAssistApiUrl = () =>
  process.env.AI_API_URL || useSelector((state) => state.layout.apiUrls.aiAssistApiUrl);
export const useMcpAppSandboxUrl = () =>
  useSelector((state) => state.layout.apiUrls.mcpAppSandboxUrl);
export const useSupportPhoneNumber = () => useSelector((state) => state.layout.support.phoneNumber);
export const useAccountMilestoneNames = () =>
  useSelector((state) => state.layout.sidebar.accountMilestoneNames);
export const useAppLinksLoading = () => useSelector((state) => state.layout.appLinksLoading);
export const useAppLinks = () => useSelector((state) => state.layout.appLinks);

// Address Modal Selectors
const ADDRESS_MODAL_CONFIG = {
  addEdit: { stateKey: "addressModal", initialState: addressModalInitialState },
  invalid: { stateKey: "invalidAddressModal", initialState: invalidAddressModalInitialState },
  verify: { stateKey: "verifyAddressModal", initialState: verifyAddressModalInitialState },
};

export const useAddressModalState = (modalType) =>
  useSelector((state) => {
    const config = ADDRESS_MODAL_CONFIG[modalType];
    return state.layout[config.stateKey] ?? config.initialState;
  });

export const useStateOptions = () => useSelector((state) => state.layout.stateOptions);
export const useStateOptionsLoading = () => useSelector((state) => state.layout.stateOptionsLoading);
